<template>
  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12 book-row radius">
    <div class="row booking-customer-list-row radius">
      <div
        class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 cell center nopadding room-image"
      >
        <img :src="roomImage" class="radius" />
      </div>
      <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12 cell padding-m">
        <div class="room-name mrg-top">{{ roomTitle }}</div>
        <div class="bold mb-1">Booking: {{ bookNumber }}</div>
        <div class="badge mb-1" :class="status.value">
          สถานะการจอง: {{ status.label }}
        </div>
        <div class="detail mrg-top">
          <div class="bold">ข้อมูลการจอง</div>
          <div>{{ customerDetail }}</div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 cell book-date mt-3">
        <div class="detail bold">วันที่จอง</div>
        <div class="tiny-size">{{ bookingDate }}</div>
      </div>
      <div
        class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12 cell center mrg-top"
      >
        <div>
          <sc-button
            variant="orange-cc radius"
            size="sm"
            @click="handleClickEditBooking"
            class="sc-btn mb-2"
            >แก้ไข</sc-button
          >
        </div>
        <div>
          <sc-button
            variant="white radius"
            size="sm"
            @click="handleClickCancel"
            class="sc-btn mb-2"
            >ยกเลิก</sc-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
     
     <script>
import ScButton from "../../../../lib/components/ScButton.vue";

export default {
  components: { ScButton },
  props: [
    "bookNumber",
    "customerName",
    "customerDetail",
    "roomTitle",
    "bookingDate",
    "bookingTimeDuration",
    "numberOfPeople",
    "status",
    "roomImage",
  ],
  methods: {
    handleClickEditBooking() {
      this.$router.push({
        name: "ConferenceBookingEditDetail",
        params: { bookingId: this.bookNumber },
      });
    },
    handleClickCancel() {},
  },
};
</script>
     
<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../../css/otherWebVariables";

.booking-customer-list-row {
  white-space: pre-line;
  content: "\A";
  padding-top: 10px;
  padding-bottom: 10px;
  background: #ffffff;

  &:hover {
    background: #e8eef5;
    cursor: pointer;
    text-decoration: none;
    color: rgb(74, 74, 74);
  }

  > .status {
    text-align: center;
  }

  > .center {
    text-align: center;
  }
}

.badge {
  font-size: 0.9rem;
  padding: 4px 10px;
  border-radius: 4px;
  margin: auto;

  &.PENDING {
    background-color: $secondary-color;
  }

  &.CONFRIMED {
    background-color: $warning-color;
  }

  &.DONE {
    background-color: $success-color;
  }

  &.CANCELED {
    background-color: $danger-color;
  }

  &.UNKNOWN {
    background-color: $danger-color;
  }
}

.sc-btn {
  width: 100%;
}


.room-name {
  font-size: $font-22;
  color: $color-orange;
  font-weight: bold;
}

.bold {
  font-weight: bold;
}

.detail {
  font-size: $font-16;
}

.book-row {
  padding-top: 5px;
  padding-bottom: 5px;
}

.room-image {
  width: inherit;
  height: inherit; /* Set the desired height for the container */
  overflow: hidden;
}

.radius {
  border-radius: 8px !important;
}

.room-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cell {
  font-size: 16px;
}

.tiny-size {
  font-size: 15px;
}

@media screen and (max-width: $ml-size) {
  .nopadding {
    padding: 0 !important;
    margin: 0 !important;
  }
  
  .booking-customer-list-row {
    padding-top: 0;
  }

  .book-row {
    padding-top: 0px;
    padding-bottom: 15px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .mrg-top {
    margin-top: 16px;
    margin-right: 15px;
  }
}

@media screen and (max-width: $m-size) {
  .cell {
    font-size: 14px;
  }

  .padding-m {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/other-web/Conference/components/BookingCustomerListRow.vue